export default __webpack_public_path__ + "static/media/bugs.2790025d.svg";